// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Zpnt","choiceBoxes":"toolbarselects_choiceBoxes__1KC1M","simpleField":"toolbarselects_simpleField__1bVP5"};